var zIndex1050 = 1050;
var zIndex10000 = 1e4;

export { zIndex10000, zIndex1050 };
